import React from 'react';
import { Header, Divider, Icon } from 'semantic-ui-react';

export const DefaultDivider = ({ name, icon }) => (
    <span>
        <Header as="h3">
            <Icon name={icon} />
            {name}
        </Header>
        <Divider />
    </span>
);
